import React from 'react';
import { CtaButton } from './CtaButton';
export function SiteHeader() {
  return <header className="sticky top-0 z-40 border-b border-cream-line/80 bg-cream/90 backdrop-blur" data-id="element-205" data-mp="19vrkx8iqh4qk">
      <div className="mx-auto flex h-16 max-w-content items-center justify-between gap-4 px-5 sm:px-8" data-id="element-206" data-mp="1nmmxausfy3yw">
        <a href="#top" className="font-display text-[18px] leading-none text-ink sm:text-[20px]" data-id="element-207" data-mp="1inbelg8ikoeo">
          The Worry-to-Brave Toolkit
        </a>
        <CtaButton size="md" className="!shadow-none" data-id="element-208" data-mp="uyr1rtelyi3p">
          <span className="sm:hidden" data-id="element-209" data-mp="qx5j1rfe79ll">Get Access</span>
          <span className="hidden sm:inline" data-id="element-210" data-mp="qyqfjml9p2m3">Get Instant Access</span>
        </CtaButton>
      </div>
    </header>;
}